export const replaceAll = (str, find, replace) => {
  return str.replace(new RegExp(find, "g"), replace);
};

export const capitalize = str => {
  if (!str) return str;

  return str.charAt(0).toUpperCase() + str.slice(1);
};
